import src from "IMAGE";
export default { src, width: 182, height: 156, blurWidth: 0, blurHeight: 0};
